export default "__VITE_ASSET__CWgxOVdS__"